import { Carousel, CarouselSlides } from '@jouzen/ecom-components';

import HeroCarouselNav from './HeroCarouselNav';
import HeroCarouselSlide, {
  type HeroCarouselSlideProps,
} from './HeroCarouselSlide';

export interface HeroCarouselProps {
  readonly slides: HeroCarouselSlideProps[];
}

const HeroCarousel = ({ slides }: HeroCarouselProps) => {
  return (
    <Carousel
      autoplay
      className="w-full max-md:h-[70svh] md:aspect-[6/5] md:max-h-[80svh] md:overflow-hidden md:rounded-r-3xl"
      data-cy="hero-carousel"
    >
      <CarouselSlides>
        {slides.map((slide, i) => (
          <HeroCarouselSlide {...slide} key={`hero-carousel-slide-${i}`} />
        ))}
      </CarouselSlides>
      <HeroCarouselNav />
    </Carousel>
  );
};

export default HeroCarousel;
